export default String.raw`
<dialog class="dialog check-availability check-availability-popup-js">
	<div class="dialog__header">
		<h2 class="dialog__header-title">{{translations.CheckAvailabilityInShop}}</h2>
		<form method="dialog">
			<button class="dialog__close close-js" aria-label="{{ translations.Close }}">
				<svg aria-hidden="true" height="24" width="24">
					<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
				</svg>
			</button>
		</form>
	</div>
	<div class="dialog__content">
		<p class="check-availability__choose-city">{{translations.ChooseCity}}</p>
		<form class="check-availability__form">
			<div class="form__input-wrapper form__input-wrapper__city">
				<select aria-label="{{ translations.ChooseCity }}" class="form__input-value input-value-js" name="city"></select>
			</div>
		</form>
		<ul class="check-availability__list check-availability-list-js"></ul>
	</div>
</dialog>

<template id="check-availability-template">
	<li class="check-availability__list-item">
		<details class="availability__details">
			<summary class="availability__summary">
				<span class="availability__shop" data-key="Name"></span>
				<div class="availability__status">
					<p class="availability__status-value">
						{% if settings.checkAvailabilityInShopPresentation == 'numbers' %}
							{{translations.Availability}}: <span data-key="Value"></span> <span> {{activeProduct.BasicUnit}}</span>
						{% else %}
							<span class="availability__status-value--word" data-key="Value" data-value="0"></span>
						{% endif %}
					</p>
					<svg height="20" width="20">
						<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}"></use>
					</svg>
				</div>
			</summary>
			<section class="availability__details-section">
				<div class="details-section__address">
					<p class="line line-title">{{translations.Address}}</p>
					<p class="line" data-key="Name"></p>
					<p class="line">
						<span data-key="Street"></span>
						<span data-key="StreetNo"></span>
						<span data-key="UnitNo"></span>
					</p>
					<p class="line">
						<span data-key="ZipCode"></span> 
						<span data-key="City"></span>
					</p>
				</div>
				<div class="details-section__hours">
					<p class="line line-title">{{translations.OpenHours}}</p>
					<p class="line" data-key="OpeningHoursMonFri">{{translations.OpeningHoursMonFri}}: </p>
					<p class="line" data-key="OpeningHoursSat">{{translations.OpeningHoursSat}}: </p>
					<p class="line" data-key="OpeningHoursSun">{{translations.OpeningHoursSun}}: </p>
				</div>
			</section>
			<section class="availability__details-section">
				<div class="details-section__contact">
					<p class="line line-title">{{translations.Contact}}</p>
					<a class="link line" data-key="Email">
						<svg height="24" width="24">
							<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#envelope-{{settings.iconStyle}}"></use>
						</svg>
					</a>
					<a class="link line" data-key="PhoneNo">
						<svg height="24" width="24">
							<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#headset-{{settings.iconStyle}}"></use>
						</svg>
					</a>
				</div>
			</section>
		</details>
	</li>
</template>
`